/**
 * Landing Page
 * 
 * Beautiful landing page for unauthenticated users with teal gradient.
 * Shows app description and login/signup CTAs.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import '../../Builder.css';
import './Landing.css';

export function LandingPage() {

    return (
        <div className="landing-page">
            {/* Background Effects */}
            <div 
                className="landing-gradient-bg"
                style={{ backgroundImage: 'url(/assets/landing/hero-gradient.svg)' }}
            ></div>
            <div className="landing-grain"></div>

            {/* Header - Matches Builder Header Style */}
            <header className="builder-header landing-builder-header">
                <div className="header-content">
                    {/* Left Section */}
                    <div className="header-left">
                        <div className="header-logo-nav">
                            <div className="header-logo">
                                <img src="/assets/header/logo.svg" alt="Threedium" />
                            </div>
                        </div>
                    </div>

                    {/* Center - Empty for landing */}
                    <div className="header-center"></div>

                    {/* Right Section - Auth Buttons */}
                    <div className="header-right header-auth-buttons">
                        <Link to="/login" className="header-login-btn">
                            Log In
                        </Link>
                        <Link to="/login" className="header-signup-btn">
                            Get started
                        </Link>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <main className="landing-hero">
                {/* Badge */}
                <div className="landing-badge">
                    <span className="badge-text">Threedium multi - Agent</span>
                    <div className="badge-status-wrapper">
                        <span className="badge-coming-soon badge-crossed">Coming Soon</span>
                        <span className="badge-now-tape">NOW</span>
                    </div>
                </div>

                {/* Hero Title */}
                <div className="landing-title">
                    <h1>
                        <span className="title-white">The Easiest Way to </span>
                        <br />
                        <span className="title-gradient">Create </span>
                        <span className="title-gradient">AI Experiences</span>
                    </h1>
                </div>

                {/* Subtitle */}
                <p className="landing-subtitle">
                    Build powerful AI-driven experiences with our visual agent builder.
                    <br />
                    No coding required — just describe what you want to create.
                </p>

                {/* CTA Buttons */}
                <div className="landing-cta">
                    <Link to="/login" className="cta-primary">
                        Start Building Free
                    </Link>
                    <a href="#features" className="cta-secondary">
                        Learn More
                    </a>
                </div>
            </main>

            {/* Footer Quote */}
            <footer className="landing-footer">
                <p className="footer-quote">
                    "The present is theirs; the future, for which I have really worked, is mine." 
                    <span className="quote-author">— Nikola Tesla</span>
                </p>
            </footer>
        </div>
    );
}

export default LandingPage;

